import { FC } from 'react'
import { useRequest } from 'ahooks'

import { toast } from '$app/utilities'

import { profile } from '$store/profile'
import { addToken } from '$store/session'

import useSignal from '$actions/useSignal'

import api from '$model/api'
import { CommonAPI } from '$api/common'

import ReplacePasswordForm, {
  ReplacePasswordFormProps
} from '$hook-forms/ReplacePasswordForm'

import { container, header, title } from './styles.css'

const { errorMessageResolver, successResolver } = new CommonAPI()

type RequestParams = Parameters<typeof api.value.auth.replacePassword>

const request = (...params: RequestParams) => {
  return api.value.auth.replacePassword(...params).then(successResolver)
}

type ReplacePasswordPorps = {
  onDone: VoidFunction
}

export const ReplacePassword: FC<ReplacePasswordPorps> = ({ onDone }) => {
  const profileData = useSignal(profile)
  const emailValue = profileData?.data?.email

  const { loading, runAsync } = useRequest(request, { manual: true })

  const onSuccess: ReplacePasswordFormProps['onSuccess'] = async (
    reset,
    data
  ) => {
    const {
      data: { auth_token }
    } = await toast
      .promise(runAsync(data), {
        loading: 'Replacing..',
        error: errorMessageResolver,
        success: 'Success!',
        duration: 5000
      })
      .unwrap()

    addToken(auth_token)

    reset()
    onDone()
  }

  return (
    <section className={container}>
      <header className={header}>
        <h2 className={title}>Replace Password</h2>
      </header>

      <ReplacePasswordForm
        onSuccess={onSuccess}
        disabled={loading}
        emailValue={emailValue}
      />
    </section>
  )
}

export default ReplacePassword
